import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-flexbox-grid';
import SubHeader from '../../components/SubHeader';
import Footer from '../../components/Footer';
import { removeHeroAnimation } from '../../actions/sharedPiecesActions';
import PurpleGlyph from '../../images/logos/nurelm-glyph-purple.svg';
import PurpleLogo from '../../images/logos/nurelm-logo-purple.svg';
import PurpleMobileLogo from '../../images/logos/nurelm-logo-horizontal-purple.svg';
import { useHeroInfo } from '../../util/queryFunctions';

const NOT_FOUND_TITLE = 'NuRelm - Not Found';

const NotFound = ({ history, location, removeHeroAnimation: removeHeroAnimationFn }) => {
  useEffect(() => {
    document.title = NOT_FOUND_TITLE;
    removeHeroAnimationFn('');
  }, [removeHeroAnimationFn])

  const { data, isFetching } = useHeroInfo();

  if (isFetching) return null;

  const locationData = data['/not-found'];

  return (
    <div className="not-found">
      <SubHeader
        history={history}
        location={location}
        mobileLogoColor={PurpleMobileLogo}
        logoColor={PurpleLogo}
        glyphColor={PurpleGlyph}
        heroOverrides={locationData}
      />
      <main>
        <div className="content-container">
          <Grid>
            <Row>
              <Col>
                <div dangerouslySetInnerHTML={{__html: locationData.theContent}} />
              </Col>
            </Row>
          </Grid>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default connect(null, { removeHeroAnimation })(NotFound);
